import './app/publicPath'

import AdvancedItemImageCarousel from './app/components/item/AdvancedItemImageCarousel.vue'

const Vue = window.Vue
Vue.component('AdvancedItemImageCarousel', AdvancedItemImageCarousel)
